// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PrivateRoute from './pages/PrivateRoute';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css'

import LoginScreen from './pages/Auth/Login';
import HomeScreen from './pages/Home';
import LocationScreen from './pages/Location';
import ProfileScreen from './pages/Profile';
import InstallerScreen from './pages/Installer';
import AboutMenuScreen from './pages/AboutMenu';
import ProductScreen from './pages/Product';
import CategoryScreen from './pages/Product/Category';
import SubCategoryScreen from './pages/Product/SubCategory';
import ProductDetailScreen from './pages/Product/ProductDetail';
import AboutUsScreen from './pages/AboutUs';
import FaqScreen from './pages/Faq';
import EditProfileScreen from './pages/Profile/EditProfile';
import MobileUpdateScreen from './pages/Profile/MobileUpdate';
import PasswordUpdateScreen from './pages/Profile/PasswordUpdate';
import ReferralScreen from './pages/Profile/Referral';
import ForgotPasswordScreen from './pages/Auth/ForgotPassword';
import InstallerApplyScreen from './pages/Installer/InstallerApply';
import InstallerDetailsScreen from './pages/Installer/InstallerDetails';
import SignUpScreen from './pages/Auth/SignUp';
import PublicRoute from './pages/PublicRoute';
import NotificationScreen from './pages/Notification';
import PurchaseHistoryScreen from './pages/Profile/PurchaseHistory';
import PurchaseViewScreen from './pages/Profile/PurchaseView';
import PromotionScreen from './pages/Home/Promotion';
import NotificationViewScreen from './pages/Notification/NotificationView';
import PointHistoryScreen from './pages/Profile/PointHistory';


function App() {
  return (
    <>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <Routes>

          {/* Public Access Menu */}
          <Route path="/" element={<HomeScreen />} />
          <Route path="/promotion/:id" element={<PromotionScreen />} />
          <Route path="/about-menu" element={<AboutMenuScreen />} />
          <Route path="/about-us" element={<AboutUsScreen />} />
          <Route path="/location" element={<LocationScreen />} />
          <Route path="/faq" element={<FaqScreen />} />
          <Route path="/products" element={<ProductScreen />} />
          <Route path="/products/:slug" element={<CategoryScreen />} />
          <Route path="/products/:slug/:sub_slug" element={<SubCategoryScreen />} />
          <Route path="/products/:slug/:sub_slug/:product_slug" element={<ProductDetailScreen />} />

          {/* Public Auth Menu */}
          <Route path="/login" element={<PublicRoute component={LoginScreen} />} />
          <Route path="/forgot-password" element={<PublicRoute component={ForgotPasswordScreen} />} />
          <Route path="/signup" element={<PublicRoute component={SignUpScreen} />} />

          {/* Private Menu */}
          <Route path="/installer" element={<PrivateRoute component={InstallerScreen} />} />
          <Route path="/installer-apply" element={<PrivateRoute component={InstallerApplyScreen} />} />
          <Route path="/installer-detail/:id" element={<PrivateRoute component={InstallerDetailsScreen} />} />

          <Route path="/profile" element={<PrivateRoute component={ProfileScreen} />} />
          <Route path="/edit-profile" element={<PrivateRoute component={EditProfileScreen} />} />
          <Route path="/mobile-update" element={<PrivateRoute component={MobileUpdateScreen} />} />
          <Route path="/password-update" element={<PrivateRoute component={PasswordUpdateScreen} />} />
          <Route path="/referral" element={<PrivateRoute component={ReferralScreen} />} />
          <Route path="/purchase-history" element={<PrivateRoute component={PurchaseHistoryScreen} />} />
          <Route path="/purchase-view/:id" element={<PrivateRoute component={PurchaseViewScreen} />} />
          <Route path="/notification" element={<PrivateRoute component={NotificationScreen} />} />
          <Route path="/noficiation-view" element={<PrivateRoute component={NotificationViewScreen} />} />
          <Route path="/point-history" element={<PrivateRoute component={PointHistoryScreen} />} />

        </Routes>
      </Router>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        rtl={false}
      />
    </>
  );
}

export default App;
